import FileSaver from 'file-saver';
import { parseContentDispositionFilename } from '../../../../../../shared/parseContentDispositionFilename';

export function downloadZip(downloadFunc: () => Promise<any>): Promise<any> {
    return downloadFunc()
        .then((response: Response) => {
            return response
                .blob()
                .then((file: Blob) => {
                    let blob = new Blob([file], {
                        type: response.headers.get('content-type')
                    });
                    FileSaver.saveAs(
                        blob,
                        parseContentDispositionFilename(
                            response.headers.get('content-disposition')
                        )
                    );
                })
                .catch((error) => {
                    console.error('error downloading images, blobbing', error);
                });
        })
        .catch((error) => {
            console.error('error downloading images', error);
        });
}
